<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit story</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New parameters of the commercial story
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-textarea dense counter rows="2" outlined auto-grow v-model="text" color="secondary"
                                    @change="onceMore()" :rules="[rules.required]">
                                </v-textarea>
                            </v-col>
                            <!-- segments weights -->
                        </v-row>
                        <v-row v-for="(item, index) in story.names" :key="item.id" justify="center" no-gutters>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="secondary" :label="`${item}`"
                                    :name="item.name" type="text" readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" class="ml-4">
                                <v-text-field dense color="secondary" label="weight" v-model.number="weights[index]"
                                    type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="editStory">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'EditCommercialStory',
    props: ['story'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            haveBeenChanged: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            //props
            text: this.story.text,
            story_weights: [],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        weights: {
            get() {
                return this.story.weights;
            },
            set(val) {
                return val;
            }
        }
    },
    methods: {
        onceMore() {
            this.error = ''
            this.message = '';
            this.haveBeenChanged = true;
        },
        async editStory() {

            if (this.$refs.form.validate()) {
                
                const story = {
                    text: this.text,
                    id: this.story.id,
                    weights: this.weights
                }
                /*  console.log(story);  */
               try {
                    //edit commertial story
                    await this.$store.dispatch('editCommercialStory', story)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.haveBeenChanged = false;
            this.value = this.story.value;
            this.text = this.story.text;
        }
    },
}
</script>